import { FC } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "@/pages/Templates/Layout";
import { PageNotFound } from "@/pages/errors/PageNotFound";
import { Dashboard } from "@/pages/Dashboard";
import { ShowComponent } from "@/pages/show-component";
import { AuthError } from "@/pages/auth/AuthError";
import { RouteAuthGuard } from "@/pages/auth/RouteAuthGuard";
import { ChargePlans } from "@/pages/ChargePlans/ChargePlans";
import ChargeSupplyDay from "@/pages/ChargeSupplyDays/ChargeSupplyDays";
import { DisplayName } from "@/models/auth";
import ChargerExclude from "@/pages/ChargerExclude/ChargerExclude";
import { ChargerExcludeDetail } from "@/pages/ChargerExclude/ChargerExcludeDetail";
import { ChargerExcludeCreate } from "@/pages/ChargerExclude/ChargerExcludeCreate";
import { ChargerExcludeEdit } from "@/pages/ChargerExclude/ChargerExcludeEdit";
import { ChargeSupplyTransaction } from "@/pages/ChargeSupplyTransaction/ChargeSupplyTransaction";
import { ContractFee } from "@/pages/ContractFee/ContractFee";
import { BillingPaymentSchedule } from "@/pages/BillingPaymentSchedule/BillingPaymentSchedule";
import { BillingPaymentScheduleConstants } from "@/pages/BillingPaymentSchedule/BillingPaymentScheduleConstants";
import { VehiclePage } from "@/pages/Vehicle/Vehicle";
import { VehicleDetail } from "@/pages/Vehicle/VehicleDetail";
import { VehicleEdit } from "@/pages/Vehicle/VehicleEdit";
import { ChargerUsageStatus } from "@/pages/ChargerUsageStatus/ChargerUsageStatus";
import { OperationPlansPage } from "@/pages/OperationPlans/OperationPlans";
import { OperationPlansEditPage } from "@/pages/OperationPlans/OperationPlansEdit";
import React from "react";
import toast from "@/components/hoc/SnackbarAlert";
import { VehicleConstants } from "@/pages/Vehicle/VehicleConstants";
import { DashboardConstants } from "@/pages/Dashboard/DashboardConstants";
import { ChargerExcludeConstants } from "@/pages/ChargerExclude/ChargerExcludeConstants";
import { OperationPlansConstansts } from "@/pages/OperationPlans/OperationPlansConstansts";
import { ChargePlansConstants } from "@/pages/ChargePlans/ChargePlansConstants";
import { ChargerUsageStatusConstants } from "@/pages/ChargerUsageStatus/ChargerUsageStatusConstants";
import { ChargeTransactionConstants } from "@/pages/ChargeSupplyTransaction/ChargeSupplyTransactionConstants";
import { ChargeSupplyDayConstants } from "@/pages/ChargeSupplyDays/ChargeSupplyDaysConstants";
import { ContractFeeConstants } from "@/pages/ContractFee/ContractFeeConstants";
import { Login } from "@/pages/auth/Login";
import { PartnerUsers } from "@/pages/PartnerUsers/PartnerUsers";
import { PartnerUserEdit } from "@/pages/PartnerUsers/PartnerUserEdit";
import { PartnerUsersConstants } from "@/pages/PartnerUsers/PartnerUsersConstants";
import { DriverWorkCycles } from "@/pages/DriverWorkCycles/DriverWorkCycles";
import { DriverWorkCyclesConstants } from "@/pages/DriverWorkCycles/DriverWorkCyclesConstants";
import { DriverWorkCycleDetails } from "@/pages/DriverWorkCycles/DriverWorkCycleDetails";
import { DriverWorkShiftEdit } from "@/pages/DriverWorkCycles/DriverWorkShiftEdit";
import { DriverWorkShiftCreate } from "@/pages/DriverWorkCycles/DriverWorkShiftCreate";
import { DriverWorkCycleEdit } from "@/pages/DriverWorkCycles/DriverWorkCycleEdit";
import { DriverWorkCycleCreate } from "@/pages/DriverWorkCycles/DriverWorkCycleCreate";
import { SettingFileUpload } from "@/pages/Vehicle/SettingFileUpload";
import { CarNoopEventsConstants } from "@/pages/CarUnderuseEvents/CarNoopEventsConstants";
import { CarNoopEventsPage } from "@/pages/CarUnderuseEvents/CarNoopEvents";
import { CarNoopEventsEditPage } from "@/pages/CarUnderuseEvents/CarNoopEventsEdit";
import { ELearningPage } from "@/pages/ELearning/ELearning";
import { ELearningConstants } from "@/pages/ELearning/ELearningConstants";
import { AccidentReportPersons } from "@/pages/AccidentReportPersons/AccidentReportPersons";
import { AccidentReportPersonsDetail } from "@/pages/AccidentReportPersons/AccidentReportPersonsDetail";
import { AccidentReportPersonsCreate } from "@/pages/AccidentReportPersons/AccidentReportPersonsCreate";
import { AccidentReportPersonsConstants } from "@/pages/AccidentReportPersons/AccidentReportPersonsConstants";
import { CarUnderuseEventsPage } from "@/pages/CarUnderuseEvents/CarUnderuseEvents";
import { CarUnderuseEventsConstants } from "@/pages/CarUnderuseEvents/CarUnderuseEventsConstants";
import { CarUnderuseEventsEditPage } from "@/pages/CarUnderuseEvents/CarUnderuseEventsEdit";
import { QuickChargerRemainingTime } from "@/pages/QuickChargerRemainingTime/QuickChargerRemainingTime";
import { QuickChargerRemainingTimeConstants } from "@/pages/QuickChargerRemainingTime/QuickChargerRemainingTimeConstants";
import { AccidentReportsPage } from "@/pages/AccidentReports/AccidentReports";
import { AccidentReportsConstants } from "@/pages/AccidentReports/AccidentReportsConstants";
import { CarNoopReasonedEventsPage } from "@/pages/CarUnderuseEvents/CarNoopReasonedEvents";
import { CarNoopReasonedEventsConstants } from "@/pages/CarUnderuseEvents/CarNoopReasonedEventsConstants";
import { CarUnderuseAnswersPage } from "@/pages/CarUnderuseEvents/CarUnderuseAnswers";
import { CarUnderuseAnswersConstants } from "@/pages/CarUnderuseEvents/CarUnderuseAnswersConstants";
import { ManualDownload } from "@/pages/Manuals/ManualDownload";
import { DriverGuideDownload } from "@/pages/DriverGuides/DriverGuideDownload";
import GoFurther from "@/pages/GoFurther/GoFurther";
import { GoFurtherConstants } from "@/pages/GoFurther/GoFurtherConstants";

export const Router: FC = () => {
  const location = useLocation();

  React.useEffect(() => {
    toast.close();
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              <RouteAuthGuard
                component={<Dashboard />}
                name={DisplayName.Dashboard}
                key={DisplayName.Dashboard}
                title={DashboardConstants.Dashboard}
              />
            }
          />
          <Route
            path="dashboard"
            element={
              <RouteAuthGuard
                component={<Dashboard />}
                name={DisplayName.Dashboard}
                key={DisplayName.Dashboard}
                title={DashboardConstants.Dashboard}
              />
            }
          />
          <Route
            path="manual/:id"
            element={
              <RouteAuthGuard
                component={<ManualDownload />}
                name={DisplayName.ManualDownload}
                key="manual-download"
                title="マニュアルダウンロード"
              />
            }
          />
          <Route
            path="driver_guides/:id"
            element={
              <RouteAuthGuard
                component={<DriverGuideDownload />}
                name={DisplayName.DriverGuideDownload}
                key="driver-guide-download"
                title="乗務員向けガイド"
              />
            }
          />
          <Route
            path="cars"
            element={
              <RouteAuthGuard
                component={<VehiclePage />}
                name={DisplayName.Cars}
                key={DisplayName.Cars}
                title={VehicleConstants.Vehicle}
              />
            }
          />
          <Route
            path="cars/:id"
            element={
              <RouteAuthGuard
                component={<VehicleDetail />}
                name={DisplayName.CarsDetail}
                key={DisplayName.CarsDetail}
                title={VehicleConstants.Detail}
              />
            }
          />
          <Route
            path="cars/:id/edit"
            element={
              <RouteAuthGuard
                component={<VehicleEdit />}
                name={DisplayName.CarsEdit}
                key={DisplayName.CarsEdit}
                title={VehicleConstants.Edit}
              />
            }
          />
          <Route
            path="cars/:id/setting_files"
            element={
              <RouteAuthGuard
                component={<SettingFileUpload />}
                name={DisplayName.SettingFileUpload}
                key={DisplayName.SettingFileUpload}
                title={VehicleConstants.SettingFileUpload}
              />
            }
          />
          <Route
            path="charger_exclude"
            element={
              <RouteAuthGuard
                component={<ChargerExclude />}
                name={DisplayName.ChargerExclude}
                key={DisplayName.ChargerExclude}
                title={ChargerExcludeConstants.ChargerExclude}
              />
            }
          />
          <Route
            path="charger_exclude/:id"
            element={
              <RouteAuthGuard
                component={<ChargerExcludeDetail />}
                name={DisplayName.ChargerExcludeDetail}
                key={DisplayName.ChargerExcludeDetail}
                title={ChargerExcludeConstants.ChargerExcludeDetails}
              />
            }
          />
          <Route
            path="charger_exclude/create"
            element={
              <RouteAuthGuard
                component={<ChargerExcludeCreate />}
                name={DisplayName.ChargerExcludeCreate}
                key={DisplayName.ChargerExcludeCreate}
                title={ChargerExcludeConstants.ChargerExcludeNewRegistration}
              />
            }
          />
          <Route
            path="charger_exclude/:id/edit"
            element={
              <RouteAuthGuard
                component={<ChargerExcludeEdit />}
                name={DisplayName.ChargerExcludeEdit}
                key={DisplayName.ChargerExcludeEdit}
                title={ChargerExcludeConstants.ChargerExcludeEdit}
              />
            }
          />
          <Route
            path="driver_work_cycles"
            element={
              <RouteAuthGuard
                component={<DriverWorkCycles />}
                name={DisplayName.DriverWorkCycles}
                key={DisplayName.DriverWorkCycles}
                title={DriverWorkCyclesConstants.DriverWorkCycleAndShifts}
              />
            }
          />
          <Route
            path="driver_work_cycles/:office_id"
            element={
              <RouteAuthGuard
                component={<DriverWorkCycleDetails />}
                name={DisplayName.DriverWorkCycleDetails}
                key={DisplayName.DriverWorkCycleDetails}
                title={DriverWorkCyclesConstants.DriverWorkCycleAndShiftsDetail}
              />
            }
          />
          <Route
            path="driver_work_cycles/:office_id/shift/:shift_id/edit"
            element={
              <RouteAuthGuard
                component={<DriverWorkShiftEdit />}
                name={DisplayName.DriverWorkShiftEdit}
                key={DisplayName.DriverWorkShiftEdit}
                title={DriverWorkCyclesConstants.DriverWorkShiftEdit}
              />
            }
          />
          <Route
            path="driver_work_cycles/:office_id/shift/create"
            element={
              <RouteAuthGuard
                component={<DriverWorkShiftCreate />}
                name={DisplayName.DriverWorkShiftCreate}
                key={DisplayName.DriverWorkShiftCreate}
                title={DriverWorkCyclesConstants.DriverWorkShiftCreate}
              />
            }
          />
          <Route
            path="driver_work_cycles/:office_id/cycle/:cycle_id/edit"
            element={
              <RouteAuthGuard
                component={<DriverWorkCycleEdit />}
                name={DisplayName.DriverWorkCycleEdit}
                key={DisplayName.DriverWorkCycleEdit}
                title={DriverWorkCyclesConstants.DriverWorkCycleEdit}
              />
            }
          />
          <Route
            path="driver_work_cycles/:office_id/cycle/create"
            element={
              <RouteAuthGuard
                component={<DriverWorkCycleCreate />}
                name={DisplayName.DriverWorkCycleCreate}
                key={DisplayName.DriverWorkCycleCreate}
                title={DriverWorkCyclesConstants.DriverWorkCycleCreate}
              />
            }
          />
          <Route
            path="operation_plans"
            element={
              <RouteAuthGuard
                component={<OperationPlansPage />}
                name={DisplayName.OperationPlans}
                key={DisplayName.OperationPlans}
                title={OperationPlansConstansts.OperationPlan}
              />
            }
          />
          <Route
            path="operation_plans/:id/edit"
            element={
              <RouteAuthGuard
                component={<OperationPlansEditPage />}
                name={DisplayName.OperationPlansEdit}
                key={DisplayName.OperationPlansEdit}
                title={OperationPlansConstansts.OperationPlanEditing}
              />
            }
          />
          <Route
            path="charge_plans"
            element={
              <RouteAuthGuard
                component={<ChargePlans />}
                name={DisplayName.ChargePlans}
                key={DisplayName.ChargePlans}
                title={ChargePlansConstants.ChargePlans}
              />
            }
          />
          <Route
            path="charger_usage_status"
            element={
              <RouteAuthGuard
                component={<ChargerUsageStatus />}
                name={DisplayName.ChargerUsageStatus}
                key={DisplayName.ChargerUsageStatus}
                title={ChargerUsageStatusConstants.UsageStatus}
              />
            }
          />
          <Route
            path="charge_supply_transactions"
            element={
              <RouteAuthGuard
                component={<ChargeSupplyTransaction />}
                name={DisplayName.ChargeSupplyTransactions}
                key={DisplayName.ChargeSupplyTransactions}
                title={ChargeTransactionConstants.SupplyTransaction}
              />
            }
          />
          <Route
            path="charge_supply_days"
            element={
              <RouteAuthGuard
                component={<ChargeSupplyDay />}
                name={DisplayName.ChargeSupplyDays}
                key={DisplayName.ChargeSupplyDays}
                title={ChargeSupplyDayConstants.SupplyDays}
              />
            }
          />
          <Route
            path="contract_fee"
            element={
              <RouteAuthGuard
                component={<ContractFee />}
                name={DisplayName.ContractFee}
                key={DisplayName.ContractFee}
                title={ContractFeeConstants.ContractFee}
              />
            }
          />
          <Route
            path="billing_payment_schedules"
            element={
              <RouteAuthGuard
                component={<BillingPaymentSchedule />}
                name={DisplayName.BillingPaymentSchedule}
                key={DisplayName.BillingPaymentSchedule}
                title={BillingPaymentScheduleConstants.Title}
              />
            }
          />
          <Route
            path="partner_users"
            element={
              <RouteAuthGuard
                component={<PartnerUsers />}
                name={DisplayName.PartnerUsers}
                key={DisplayName.PartnerUsers}
                title={PartnerUsersConstants.PartnerUser}
              />
            }
          />
          <Route
            path="partner_users/:id"
            element={
              <RouteAuthGuard
                component={<PartnerUserEdit />}
                name={DisplayName.PartnerUserEdit}
                key={DisplayName.PartnerUserEdit}
                title={PartnerUsersConstants.PartnerUserEdit}
              />
            }
          />
          <Route
            path="accident_reports"
            element={
              <RouteAuthGuard
                component={<AccidentReportsPage />}
                name={DisplayName.IncidentReport}
                key={DisplayName.IncidentReport}
                title={AccidentReportsConstants.AccidentReports}
              />
            }
          />
          <Route
            path="accident_report_persons"
            element={
              <RouteAuthGuard
                component={<AccidentReportPersons />}
                name={DisplayName.IncidentReport}
                key={DisplayName.IncidentReport}
                title={AccidentReportPersonsConstants.ListTitle}
              />
            }
          />
          <Route
            path="accident_report_persons/create"
            element={
              <RouteAuthGuard
                component={<AccidentReportPersonsCreate />}
                name={DisplayName.IncidentReport}
                key={DisplayName.IncidentReport}
                title={AccidentReportPersonsConstants.CreateTitle}
              />
            }
          />
          <Route
            path="accident_report_persons/:id"
            element={
              <RouteAuthGuard
                component={<AccidentReportPersonsDetail />}
                name={DisplayName.IncidentReport}
                key={DisplayName.IncidentReport}
                title={AccidentReportPersonsConstants.DetailTitle}
              />
            }
          />
          <Route
            path="car_noop_events"
            element={
              <RouteAuthGuard
                component={<CarNoopEventsPage />}
                name={DisplayName.CarNoopEvents}
                key={DisplayName.CarNoopEvents}
                title={CarNoopEventsConstants.CarUnderuseEvents}
              />
            }
          />
          <Route
            path="car_noop_events/:id/edit"
            element={
              <RouteAuthGuard
                component={<CarNoopEventsEditPage />}
                name={DisplayName.CarNoopEventsEdit}
                key={DisplayName.CarNoopEventsEdit}
                title={CarNoopEventsConstants.Edit}
              />
            }
          />
          <Route
            path="car_noop_events/reasons"
            element={
              <RouteAuthGuard
                component={<CarNoopReasonedEventsPage />}
                name={DisplayName.CarNoopReasonedEvents}
                key={DisplayName.CarNoopReasonedEvents}
                title={CarNoopReasonedEventsConstants.CarNoopReasonedEvents}
              />
            }
          />
          <Route
            path="car_underuse_events"
            element={
              <RouteAuthGuard
                component={<CarUnderuseEventsPage />}
                name={DisplayName.CarUnderuseEvents}
                key={DisplayName.CarUnderuseEvents}
                title={CarUnderuseEventsConstants.CarUnderuseEvents}
              />
            }
          />
          <Route
            path="car_underuse_events/:id/edit"
            element={
              <RouteAuthGuard
                component={<CarUnderuseEventsEditPage />}
                name={DisplayName.CarUnderuseEventsEdit}
                key={DisplayName.CarUnderuseEventsEdit}
                title={CarUnderuseEventsConstants.Edit}
              />
            }
          />
          <Route
            path="car_underuse_events/answers"
            element={
              <RouteAuthGuard
                component={<CarUnderuseAnswersPage />}
                name={DisplayName.CarUnderuseAnswers}
                key={DisplayName.CarUnderuseAnswers}
                title={CarUnderuseAnswersConstants.CarUnderuseAnswers}
              />
            }
          />
          <Route
            path="elearning/:id"
            element={
              <RouteAuthGuard
                component={<ELearningPage />}
                name={DisplayName.ELearning}
                key={DisplayName.ELearning}
                title={ELearningConstants.ELearning}
              />
            }
          />
          <Route
            path="quick_charger_remaining_time"
            element={
              <RouteAuthGuard
                component={<QuickChargerRemainingTime />}
                name={DisplayName.QuickChargerRemainingTime}
                key={DisplayName.QuickChargerRemainingTime}
                title={QuickChargerRemainingTimeConstants.Title}
              />
            }
          />
          <Route
            path="go_further"
            element={
              <RouteAuthGuard
                component={<GoFurther />}
                name={DisplayName.RevenueSimulations}
                key={DisplayName.RevenueSimulations}
                title={GoFurtherConstants.Title}
              />
            }
          />
          <Route path="show-component" element={<ShowComponent />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>

        <Route
          path="/login"
          element={
            <RouteAuthGuard
              component={<Login />}
              key={DisplayName.Dashboard}
              name={DisplayName.Dashboard}
              title={PartnerUsersConstants.PartnerUser}
            />
          }
        />
        <Route path="/auth-error" element={<AuthError />} />
      </Routes>
    </>
  );
};
